import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ColorButton from 'src/components/atoms/ColorButton'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { vwSize } from 'src/utils/vwCss'
// images
import LogoImage from 'src/images/shared/commmune-logo-white.png'
import FooterLogo from 'src/images/top/commmune-logo.svg'
import twitterIcon from 'src/images/shared/twitter.svg'
import facebookIcon from 'src/images/shared/facebook.svg'
import bgCV from 'src/images/shared/footer_cv.png'
import bgCVSp from 'src/images/shared/footer_cv_sp.png'
import icoExtlink from 'src/images/shared/icon_extlink.svg'

type CVItemProps = {
  first?: boolean
}

class Footer extends React.Component {
  render() {
    return (
      <Container>
        <BackGroundBlue>
          <CVArea>
            <Text>
              <NoLineBreak>企業とユーザーが</NoLineBreak>
              <NoLineBreak>融け合う</NoLineBreak>
              <NoLineBreak>コミュニティサクセス</NoLineBreak>
              <NoLineBreak>プラットフォーム</NoLineBreak>
            </Text>
            <Logo src={LogoImage} />
            <CVWrapper>
              <CVItem first>
                <ButtonWrap className={"g-btn -orange"}>
                  <ColorButton
                    text="資料ダウンロード"
                    size="fill"
                    to="/whitepapers/commmune_introduction/"
                    arrow={false}
                    outer={false}
                    css={ColorButtonText}
                  />
                </ButtonWrap>
              </CVItem>
              <CVItem>
                <ButtonWrap className={"g-btn -white"}>
                  <ColorButton
                    text="お問い合わせ"
                    size="fill"
                    color="white"
                    to="/contact/"
                    arrow={false}
                    css={ColorButtonText}
                  />
                </ButtonWrap>
              </CVItem>
            </CVWrapper>
          </CVArea>
        </BackGroundBlue>
        <UnderContents>
          <UnderContentsWrap>
            <FooterMenu>
              <FooterBlock>
                <FooterLogoWrap>
                  <LogoFooter src={FooterLogo} />
                </FooterLogoWrap>
                <SNSLinkLine>
                  <FooterSNSLink href="https://www.facebook.com/commmunejp/" target="_blank" className={"no-icon"}>
                    <SNSIcon
                      src={facebookIcon}
                      alt="commmuneのfacebookアカウントページ"
                    />
                  </FooterSNSLink>
                  <FooterSNSLink href="https://twitter.com/commmunejp" target="_blank" className={"no-icon"}>
                    <SNSIcon
                      src={twitterIcon}
                      alt="commmuneのtwitterアカウントページ"
                    />
                  </FooterSNSLink>
                </SNSLinkLine>
              </FooterBlock>
              <FooterBlockWrap>
                <FooterBlock>
                  <MenuList>
                    <MenuItem>
                      <LinkText href="/plan/">料金体系</LinkText>
                    </MenuItem>
                    <MenuItem>
                      <LinkText href="/case/">導入事例</LinkText>
                    </MenuItem>
                    <MenuItem>
                      <LinkText href="/event/">イベント情報</LinkText>
                    </MenuItem>
                    <MenuItem>
                      <LinkText href="/whitepapers/">お役立ち資料</LinkText>
                    </MenuItem>
                    <MenuItem>
                      <LinkText href="/news/">ニュース</LinkText>
                    </MenuItem>
                    <MenuItem>
                      <LinkText href="/blog/">ブログ</LinkText>
                    </MenuItem>
                  </MenuList>
                </FooterBlock>
                <FooterBlock>
                  <MenuList>
                    <MenuItem>
                      <LinkText href="https://commmune-careers.studio.site/" target="_blank">採用情報</LinkText>
                      <MenuList css={FooterMenuSub}>
                        <MenuItem>
                          <MenuItem>
                            <LinkText href="https://tech.commmune.jp/" target="_blank">─ 開発者ブログ</LinkText>
                          </MenuItem>
                          <MenuItem>
                            <LinkText href="https://note.com/commmune/" target="_blank">─ note</LinkText>
                          </MenuItem>
                          <MenuItem>
                            <LinkText href="https://www.youtube.com/channel/UCzXDa19fFbTIB3t8SHzcTVQ" target="_blank">─ youtube</LinkText>
                          </MenuItem>
                          <MenuItem>
                            <LinkText href="https://podcastranking.jp/1621502821" target="_blank">─ podcast</LinkText>
                          </MenuItem>
                        </MenuItem>
                      </MenuList>
                    </MenuItem>
                  </MenuList>
                </FooterBlock>
              </FooterBlockWrap>
              <FooterBlock>
                <MenuList css={MenuInline}>
                  <MenuItem>
                    <LinkText href="/company/">企業情報</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="/membership_agreement/">お客様向け規約</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="/user_agreement/">ユーザー向け規約</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="/security_policy/">情報セキュリティ方針</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="/cookie_policy/">クッキーポリシー</LinkText>
                  </MenuItem>
                </MenuList>
              </FooterBlock>
              <FooterBlock>
                <MenuList css={MenuInline}>
                  <MenuItem>
                    <LinkText href="https://community.commmune.com/view/box?boxId=knowledgeBase001&categoryIndex=99" target="_blank">ヘルプページ</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="/privacy_policy/">プライバシーポリシー(個人情報保護方針)</LinkText>
                  </MenuItem>
                  <MenuItem>
                    <LinkText href="https://commmune.com/?locale=ja" target="_blank">アカウントをお持ちの方はこちら</LinkText>
                  </MenuItem>
                </MenuList>
              </FooterBlock>
            </FooterMenu>
            <CopyRight>
              <Rights as="p">©️Commmune Inc. All rights reserved</Rights>
            </CopyRight>
          </UnderContentsWrap>
        </UnderContents>
      </Container>
    )
  }
}

const SNSLinkLine = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: ${vwSize(24, 'pc')}vw 0 0; 
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin: ${vwSize(24, 'sp')}vw 0 0; 
  }
`
const FooterSNSLink = styled.a`
  width: ${vwSize(32, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: ${vwSize(32, 'sp')}vw;
  }

  &:first-of-type {
    margin-right: ${vwSize(16, 'pc')}vw;
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      margin-right: ${vwSize(16, 'sp')}vw;
    }
  }
`
const SNSIcon = styled.img`
  width: 100%;
`


const Container = styled.div`
  position: relative;
`

const BackGroundBlue = styled.div`
  position: relative;
  background-image: url(${bgCV});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    background-image: url(${bgCVSp});
  }
`
const CVArea = styled.div`
  padding: ${vwSize(80, 'pc')}vw 0;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: ${vwSize(64, 'sp')}vw 0;
  }
`
const ButtonWrap = styled.div`
`

const UnderContents = styled.div`
  position: relative;
  padding-bottom: ${vwSize(50, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding-bottom: ${vwSize(20, 'sp')}vw;
  }
`
const UnderContentsWrap = styled.div`
  padding: ${vwSize(90, 'pc')}vw  ${vwSize(180, 'pc')}vw 0; 
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding: ${vwSize(70, 'sp')}vw  ${vwSize(20, 'sp')}vw 0; 
  }
`
const FooterMenu = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
  }

  a {
    &:hover {
      opacity: 0.6;
    }

    &[target=_blank] {
      position: relative;

      &:after {
        content: "";
        width: ${vwSize(10, 'pc')}vw;
        height: ${vwSize(10, 'pc')}vw;
        background-image: url(${icoExtlink});
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        right: -1.2em;
        top: 50%;
        transform: translateY(-50%);
        @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
          width: ${vwSize(10, 'sp')}vw;
          height: ${vwSize(10, 'sp')}vw;
        }
      }
    }

    &.no-icon {
      &[target=_blank] {
          &:after {
            content: none;
          }
      }
    }
  }
`
const FooterBlockWrap = styled.div`
  display: flex;
  justify-content: flex-start;

  > div:first-of-type {
    margin-right: ${vwSize(48, 'pc')}vw;
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      margin-right: ${vwSize(48, 'sp')}vw;
    }
  }
`
const FooterBlock = styled.div`
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-bottom: ${vwSize(24, 'sp')}vw;
  }
`
const FooterLogoWrap = styled.div`
  width: ${vwSize(198, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: ${vwSize(196, 'sp')}vw;
  }
`
const LogoFooter = styled.img`
  width: 100%;
`
const MenuList = styled.ul`
`
const MenuItem = styled.li`
  margin-bottom: ${vwSize(20, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-bottom: ${vwSize(20, 'sp')}vw;
  }
  &:last-child {
    margin-bottom: 0;
  }
`
const MenuInline = css`
  li {
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      display: inline-block;
      margin-right: ${vwSize(16, 'sp')}vw;
      margin-bottom: ${vwSize(10, 'sp')}vw;
    }
  }
`
const LinkText = styled.a`
  font-weight: 700;
  color: ${Styles.color.primary[400]};
  font-size: ${vwSize(14, 'pc')}vw;
  text-decoration: none;
  letter-spacing: 0.06em;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(14, 'sp')}vw;
  }
`

const FooterMenuSub = css`
  margin-top: ${vwSize(16, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(16, 'sp')}vw;
  }

  a {
    font-weight: normal;

  }
`

const CopyRight = styled.div`
  margin-top: ${vwSize(80, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(70, 'sp')}vw;
  }
`

const Text = styled(Typography)`
  font-size: ${vwSize(24, 'pc')}vw;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.06em;
  color: #ffffff;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(24, 'sp')}vw;
    line-height: 1.6;
  }
`

const Logo = styled.img`
  width: 100%;
  max-width: 360px;
  margin-top: ${vwSize(32, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: 85.3vw;
    margin-top: 5vw;
  }
`

const CVWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${vwSize(64, 'pc')}vw;

  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(34, 'sp')}vw;
    flex-direction: column;
    align-items: center;
  }
`

const CVItem = styled.div<CVItemProps>`
  width: ${vwSize(320, 'pc')}vw;
  align-items: center;
  border-right: ${({ first }) => (first ? 'solid 1px #ffffff' : '')};
  border: none;
  margin-right: ${({ first }) => (first ? `${vwSize(80, "pc")}vw` : '')};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    width: ${vwSize(320, 'sp')}vw;
    margin-right: 0;
    border: none;
    margin-bottom: ${({ first }) => (first ? `${vwSize(24, "sp")}vw` : '')};
  }
`
const ColorButtonText = css`
  font-size: ${vwSize(18, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(18, 'sp')}vw;
  }
`

const Rights = styled(Typography)`
  font-size: ${vwSize(14, 'pc')}vw;
  text-align: center;
  color: ${Styles.color.primary[400]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(14, 'sp')}vw;
  }
`

export default Footer

